import cardblogfullbgauthor from "_texts/presentation/cards/cardblogfullbgauthor.js";

const textProps = {
  heading2badge: {
    badge: {
      color: "red",
      children: "new arrival",
    },
    title: "Latest Blogpost",
    description:
      "It's the same place where you do not have courage, there is no way you want it. It is possible that you will give, but it is more probable that you will recieve.",
    alignment: "left",
  },
  card: { ...cardblogfullbgauthor },
};
export default textProps;
